import { rgb } from "d3-color";

export function colorContrast({r, g, b}, black = rgb(0, 0, 0), white = rgb(255, 255, 255)) {
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return (yiq >= 128) ? black : white;
}
